import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/prop-types */
/* This is the same as the side-nav-menu-item, product-menu-item, sub-nav-start-item, sub-nav-end-item renderers and is going to be replaced with a generic solution */
import React, { Component } from 'react';
import { ProductSpecificNavItem } from '@sitebase/web-shell-kit/es/header-kit/product-specific-nav';
import IconAsset from '@sitebase/web-shell-kit/es/header-kit/IconAsset';

import { publish, subscribe, unsubscribe } from '../patched-message-bus';
import { eventRequested, eventSelected, onCommandSelect } from './message-bus-helpers';

var type = '@sitebase/sub-nav-start-item';
var sharedSelectedId = '';

var _onClick = function _onClick(e, data) {
  if (e) e.preventDefault();
  publish(eventRequested(data));
};

var SubNavStartItemRender = function (_Component) {
  _inherits(SubNavStartItemRender, _Component);

  function SubNavStartItemRender() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SubNavStartItemRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubNavStartItemRender.__proto__ || _Object$getPrototypeOf(SubNavStartItemRender)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedId: sharedSelectedId
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SubNavStartItemRender, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.subscribeId = subscribe(onCommandSelect(function (data) {
        var selectedId = _this2.state.selectedId;

        if (selectedId !== data.id) {
          _this2.setState({ selectedId: data.id }, function () {
            sharedSelectedId = data.id;
            publish(eventSelected(data));
          });
        }
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.subscribeId) unsubscribe(this.subscribeId);
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;
      var selectedId = this.state.selectedId;
      var id = data.id,
          label = data.label,
          icon = data.icon,
          _data$link = data.link,
          link = _data$link === undefined ? {} : _data$link;


      return React.createElement(
        ProductSpecificNavItem,
        _extends({
          'data-test-id': '' + type + (id ? '_' + id : '')
        }, link, {
          href: link.url,
          active: selectedId === id,
          onClick: function onClick(e) {
            return _onClick(e, data);
          }
        }),
        !!icon && React.createElement(IconAsset, { name: icon }),
        label
      );
    }
  }]);

  return SubNavStartItemRender;
}(Component);

SubNavStartItemRender.defaultProps = {
  data: {}
};


export default {
  type: type,
  render: function render(_ref2) {
    var data = _ref2.data;
    return React.createElement(SubNavStartItemRender, { key: data.id || data.label, data: data });
  }
};
//# sourceMappingURL=sub-nav-start-item.js.map